module.exports = function(fn) {
  return function(a) {
    return fn.apply(null, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/arity-n/1.js
// module id = ./node_modules/arity-n/1.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons